import moment, { Moment } from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import ISemana from './../../../interfaces/ISemana';
import IMes from './../../../interfaces/IMes';
import IProyecto from '../../../interfaces/IProyecto';
import IPlanificacion from '../../../interfaces/IPlanificacion';

const useSemana = (mes: IMes, proyecto: IProyecto, semanaInicial: string, nextMonthWeek: boolean): [any, ISemana, any] => {
  const [semanas, setSemanas] = useState(null);
  const [semanaSelected, setSemana] = useState(null);

  const setSemanaSelected = (semana: ISemana) => {
    if (semana) {
      const semanaNueva = semanas.find((s: any) => s.id === semana.id);
      setSemana(semanaNueva);
    } else {
      setSemana(null);
    }
  };

  const filtrarNoPlanificadas = (semanas: Array<ISemana>, planificacion: Array<IPlanificacion>, mes: IMes) => {
    if (!mes) return [];
    return semanas.filter((s) =>
      [0, 2, 3, 4].some((offset) => {
        const dia = s.primerDia.clone().add(offset, 'days');
        return esUnDiaDelMes(dia, mes) && esDiaAsignado(dia, planificacion);
      })
    );
  };

  const esUnDiaDelMes = (dia: Moment, mes: IMes): boolean => {
    return dia.month() === mes.key;
  };

  const esDiaAsignado = (dia: Moment, asignaciones: Array<IPlanificacion>) => {
    return asignaciones.some((a) => dia.isSame(moment(a.fecha, 'YYYY-MM-DD')));
  };

  const getSemanaMasCercana = (semanas: Array<ISemana>, fecha: Moment) => {
    fecha = fecha.startOf('isoWeek');
    let masCercano = semanas[0];
    for (const semana of semanas) {
      const difSemana = Math.abs(semana.primerDia.diff(fecha, 'd'));
      const difActual = Math.abs(masCercano.primerDia.diff(fecha, 'd'));
      if (difSemana < difActual) {
        masCercano = { ...semana, primerDia: semana.primerDia.clone() };
      }
    }
    return nextMonthWeek ? semanas[0] : masCercano;
  };

  useEffect(() => {
    if (proyecto && Array.isArray(proyecto.planificacion) && mes) {
      let primerDia = moment(mes.value, 'MMMM YYYY').startOf('M');
      if (primerDia.day() > 5) {
        primerDia = primerDia.add(1, 'week').startOf('week');
      }

      primerDia = primerDia.startOf('week');

      const primerDiaUltimaSemana = moment(mes.value, 'MMMM YYYY').endOf('M').startOf('week');
      let nuevasSemanas = [];
      for (; primerDia.isSameOrBefore(primerDiaUltimaSemana); primerDia.add(1, 'week')) {
        nuevasSemanas.push({
          primerDia: primerDia.clone(),
          id: primerDia.week(),
          value: 'Semana ' + primerDia.format('DD/MM'),
        });
      }
      nuevasSemanas = filtrarNoPlanificadas(nuevasSemanas, proyecto.planificacion, mes);
      setSemanas(nuevasSemanas);
      if (semanaSelected === null && nuevasSemanas.length > 0) {
        if (semanaInicial) {
          setSemana(getSemanaMasCercana(nuevasSemanas, moment(semanaInicial, 'w')));
        } else {
          setSemana(getSemanaMasCercana(nuevasSemanas, moment()));
        }
      }
    }

  }, [proyecto, mes]);

  return [semanas, semanaSelected, setSemanaSelected];
};

export default useSemana;